'use strict'

//import config from './../../configuration'
import Axios from 'axios'
import configuration from '../../configuration';
const url = configuration.apiHost;

export default class UtilService {

  static async findAddressByCep(cep) {
    try {
      let response = await Axios.get(`https://api.postmon.com.br/v1/cep/${cep}`);
      return {
        cep: cep,
        addressType: response.data.logradouro,
        district: response.data.bairro,
        city: response.data.cidade,
        state: response.data.estado_info.nome,
      }
    } catch (error) {
      throw `UtilService: Erro ao buscar endereço por CEP: ${error.response.data}`
    }
  } // findAddressByCep()

}



// WEBPACK FOOTER //
// ./src/service/UtilService.js